import type {
    OrthodontistDetailInfo,
    UpdateOrthodontistBody
} from '../../../../services/orthodontistAccounts';
import {
    ORTHODONTIST_CREATE_FIELDS,
    type OrthodontistFieldDef
} from '../create/orthodontistCreateFields.ts';

const DOCTOR_FIELD_KEYS = new Set<string>(['drFirstName', 'drLastName', 'drEmail']);

export const ORTHODONTIST_ORGANIZATION_FIELDS = ORTHODONTIST_CREATE_FIELDS.filter(
    (field) => !DOCTOR_FIELD_KEYS.has(field.key)
);
export const ORTHODONTIST_DOCTOR_FIELDS = ORTHODONTIST_CREATE_FIELDS.filter((field) =>
    DOCTOR_FIELD_KEYS.has(field.key)
);

export const ORTHODONTIST_FIELD_DEFS: Record<string, OrthodontistFieldDef> = Object.fromEntries(
    ORTHODONTIST_CREATE_FIELDS.map((field) => [field.key, field])
);

export function flattenOrthodontistInfo(info: OrthodontistDetailInfo): Record<string, string> {
    return Object.fromEntries(
        ORTHODONTIST_CREATE_FIELDS.map((field) => [field.key, info[field.key] ?? ''])
    );
}

// Required fields keep '' so validation can reject them; the server never accepts null there.
export function buildOrthodontistInfoUpdate(
    original: OrthodontistDetailInfo,
    values: Record<string, string>
): UpdateOrthodontistBody {
    const changed = ORTHODONTIST_CREATE_FIELDS.flatMap((field) => {
        const next = (values[field.key] ?? '').trim();
        if (next === (original[field.key] ?? '').trim()) return [];
        return [[field.key, next === '' && !field.required ? null : next]];
    });
    return Object.fromEntries(changed);
}
